import { Buffer } from 'buffer'
import process from 'process/browser'

if (typeof globalThis !== 'undefined' && !globalThis.Buffer) {
  globalThis.Buffer = Buffer
}

if (typeof globalThis !== 'undefined' && !globalThis.process) {
  globalThis.process = process
}

if (typeof window !== 'undefined' && !window.Buffer) {
  window.Buffer = Buffer
}

if (typeof window !== 'undefined' && !window.process) {
  window.process = process
}

if (typeof self !== 'undefined' && !self.Buffer) {
  self.Buffer = Buffer
}

if (typeof self !== 'undefined' && !self.process) {
  self.process = process
}
